import React, { useEffect, useRef, useState } from "react";

import { CircularIndeterminate, FormButton } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { GoogleMap, Marker, LoadScript } from "@react-google-maps/api";
import { Box, Grid } from "@mui/material";
import { RNHAreaGet } from "services/services-mia/RNHAreaGet";
import { localidadesGet } from "services/services-mia/localidadesGet";
import { RNHNivelGet } from "services/services-mia/RNHNivelGet";
import { RNHHospitalGet } from "services/services-mia/RNHHospitalGet";
import { RNHHospitalUpd } from "services/services-mia/RNHHospitalUpd";
import { RNHUnidadGet } from "services/services-mia/RNHUnidadGet";
import { RNHZonaGet } from "services/services-mia/RNHZonaGet";

const libraries = ["places"];

const containerStyle = {
    width: "100%",
    maxWidth: "726px",
    // height: "100%",
    marginBottom: ".2rem",
    marginTop: "2rem",
    display: "flex",
    justifyContent: "end",
};

const cabeceraOpt = {
    "B": "De zona y de area",
    "N": "Ni de area ni de zona",
    "A": "De area",
    "Z": "De zona"
}

export default function ViewModal({ updateList, user, closeModal, latitud, longitud }) {
    const credentials = useRecoilValue(userCredentials);
    const [coordenadas, setCoordenadas] = useState({
        lat: latitud
            ? typeof latitud === "number"
                ? latitud
                : parseFloat(latitud)
            : -38.951666,
        lng: longitud
            ? typeof longitud === "number"
                ? longitud
                : parseFloat(longitud)
            : -68.074444,
    });
    const formikRef = useRef();
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const getData = async () => {
        setIsLoading(true);
        const hospital = await RNHHospitalGet(credentials, { id: user.id })
        setData(hospital[0])
        formikRef.current.setValues({
            cod: hospital[0].rnhHospitalCod,
            nombre: hospital[0].rnhHospitalNombre,
            localidadId: hospital[0].localidadNombre,
            areaId: hospital[0].rnhAreaNombre,
            zonaId: hospital[0].rnhZonaNombre,
            nivelId: hospital[0].rnhNivelNombre,
            cabecera: cabeceraOpt[hospital[0].rnhHospitalCabecera],
            calle: hospital[0].rnhHospitalCalle,
            numero: hospital[0].rnhHospitalNumero,
            piso: hospital[0].rnhHospitalPiso,
            lat: hospital[0].rnhHospitalLatitud,
            lng: hospital[0].rnhHospitalLongitud
        })
        setCoordenadas({
            lat: hospital[0].rnhHospitalLatitud,
            lng: hospital[0].rnhHospitalLongitud
        })
        setIsLoading(false);
    }

    useEffect(() => {
        getData()
    }, []);
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                cod: "",
                nombre: "",
                localidadId: "",
                areaId: "",
                zonaId: "",
                nivelId: "",
                cabecera: "",
                calle: "",
                numero: "",
                unidad: "",
                zonaId: "",
                piso: "",
            }}
            validationSchema={
                yup.object({
                    cod: yup.string("Debe ingresar un Código").max(20, "Debe tener menos de 20 caracteres").required("Debe ingresar un Código"),
                    nombre: yup.string("Debe ingresar un nombre").max(100, "Debe tener menos de 100 caracteres").required("Debe ingresar un nombre"),
                    calle: yup.string("Debe ingresar una calle").max(70, "Debe tener menos de 70 caracteres").required("Debe ingresar una calle"),
                    numero: yup.string("Debe ingresar un numero").max(10, "Debe tener menos de 10 caracteres").required("Debe ingresar un numero"),
                    localidadId: yup.string("Debe seleccionar una localidad").required("Debe seleccionar una localidad"),
                    areaId: yup.string("Debe seleccionar un área").required("Debe seleccionar un área"),
                    nivelId: yup.string("Debe seleccionar un nivel").required("Debe seleccionar un nivel"),
                })
            }
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <Grid width={"100%"}>
                        {!isLoading && <Box display={"flex"} flexDirection={"column"} width={"100%"} gap={1}>
                            <Box display={"flex"} width={"100%"} gap={2}>
                                <FormikTextInput
                                    readOnly={true}
                                    fullWidth={true}
                                    name="cod"
                                    labelText="Código"
                                />
                                <FormikTextInput
                                    readOnly={true}
                                    fullWidth={true}
                                    name="nombre"
                                    labelText="Nombre"
                                />
                            </Box>
                            <Box display={"flex"} width={"100%"} gap={2}>
                                <FormikTextInput
                                    readOnly={true}
                                    fullWidth={true}
                                    name="localidadId"
                                    labelText="Localidad"
                                />
                               <FormikTextInput
                                    readOnly={true}
                                    fullWidth={true}
                                    name="zonaId"
                                    labelText="Zona sanitaria"
                                />
                                <FormikTextInput
                                    readOnly={true}
                                    fullWidth={true}
                                    name="areaId"
                                    labelText="Área programa"
                                />
                                <FormikTextInput
                                    readOnly={true}
                                    fullWidth={true}
                                    name="cabecera"
                                    labelText="Cabecera"
                                />
                            </Box>
                        </Box>}
                        <Box display={"flex"} width={"100%"} gap={2}>
                            {isLoading ? <div style={{ minWidth: "30%" }}><CircularIndeterminate /></div> : <Box display={"flex"} flexDirection={"column"} minWidth={"30%"} gap={1}>
                                <h3 style={{ margin: "0", marginTop: "8px" }}>Domicilio</h3>
                                    <Box display={"flex"} width={"100%"} gap={2}>
                                        <FormikTextInput
                                            readOnly={true}
                                            fullWidth={true}
                                            name="calle"
                                            labelText="Calle"
                                        />
                                        <FormikTextInput
                                            readOnly={true}
                                            fullWidth={true}
                                            name="numero"
                                            labelText="Numero"
                                        />
                                    </Box>
                                    <Box display={"flex"} width={"100%"} gap={2}>
                                        <FormikTextInput
                                            readOnly={true}
                                            fullWidth={true}
                                            name="piso"
                                            labelText="Piso"
                                        />
                                        <FormikTextInput
                                            readOnly={true}
                                            fullWidth={true}
                                            name="unidad"
                                            labelText="Unidad"
                                        />
                                    </Box>
                                    <Box display={"flex"} width={"100%"} gap={2}>
                                        <FormikTextInput
                                    readOnly={true}
                                    fullWidth={true}
                                    name="localidadId"
                                    labelText="Localidad"
                                />
                                        <FormikTextInput
                                            readOnly={true}
                                            fullWidth={false}
                                            name="cpa"
                                            labelText="CPA"
                                        />
                                    </Box>
                                    <Box display={"flex"} width={"100%"} gap={2}>
                                        <FormikTextInput
                                            fullWidth={true}
                                            name="lat"
                                            labelText="Latitud"
                                            readOnly={true}
                                        />
                                        <FormikTextInput
                                            fullWidth={true}
                                            name="lng"
                                            labelText="Longitud"
                                            readOnly={true}
                                        />
                                    </Box>
                            </Box>}
                            <LoadScript
                                id="second-google-map-script"
                                googleMapsApiKey="AIzaSyA3CvTeFPuHo7ePjm5YOva66gR-pFWZvPc"
                                libraries={libraries}
                                style={{ width: "50%", height: "100%", display: "flex", justifyContent: "end", alignItems: "center" }}
                            >
                                <GoogleMap
                                    mapContainerStyle={containerStyle}
                                    center={coordenadas}
                                    zoom={8}
                                >
                                    <Marker position={coordenadas} draggable={false} />
                                </GoogleMap>
                            </LoadScript>
                        </Box>
                    </Grid>
                    <FormButton
                        oneButton={true}
                        // inRequest={inRequest || isLoading}
                        newFormData={{ button: "Aplicar" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
